module.exports = __webpack_public_path__ + "static/intro-289ff96a07589eb37fc901a277da4ddf.jpg";